import React, { Component } from 'react'
// import Index from './containers'
import SaoPauloExpo from './containers/saopauloexpo'
import StartSe from './containers/startse'
import NewOffice from './containers/newoffice'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import './App.css'
import './static/css/style.css'

// const Child = ({ match }) => {
//   return (
//     <Index organizador={match.params.organizador} />
//   )
// }

export default class Routes extends Component {
  render () {
    return (
      <BrowserRouter>
        <Switch>
          {/* <Route path='/:organizador' component={Child} /> */}
          <Route exact path={['/saopauloexpo', '/sp-expo', '/spexpo']} component={SaoPauloExpo} />
          <Route exact path='/startse' component={StartSe} />
          <Route exact path='/new-office' component={NewOffice} />
        </Switch>
      </BrowserRouter>
    )
  }
}
